/*# sourceMappingURL=admin-panel-company-detail-form.component-TS2ZO2XZ.css.map */
